const specs = {
  standard: {
    operation: 'create',
    create: {
      type: 'number',
      product: 'exterior3d_standard',
    },
  },
  viewCount: {
    operation: 'update',
    update: {
      type: 'mapTo',
      target: '@{product.id} == "exterior3d_standard"',
      mapTo: [ 'viewCount' ],
    },
  },
  droneShooting: {
    operation: 'update',
    update: {
      type: 'mapTo',
      target: '@{product.id} == "exterior3d_standard"',
      mapTo: [ 'droneShooting' ],
    },
  },
};


const dependencies = {
  hard: [],
  soft: [
    {
      if: {
        key: 'droneShooting',
        value: true,
      },
      then: {
        operation: 'createOrUpdate',
        createOrUpdate: {
          product: 'droneShooting_standard',
          service: 'droneShooting',
          with: { exterior3d: true },
        },
      },
    }
  ],
};


export default { specs, dependencies };
